import { Inject } from '@odinjs/odin';

import { PanelAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';

import { FragmentNames, ModalItemTissAliases } from '../../codegen';
import BaseController from '../base/base-controller';

@Controller({ fragment: FragmentNames.MODAL_ITEM_TISS })
export default class ModalItemTissController extends BaseController {

  @Inject(ModalItemTissAliases.PANEL_QUIMIO)
  private panelQuimio: PanelAPI;
  @Inject(ModalItemTissAliases.PANEL_OPME)
  private panelOpme: PanelAPI;

  @OnMount(ModalItemTissAliases.PANEL_ITEM_TISS)
  onMount(): void {
    const { ieTipoAnexo } = this.context.getBulkData();

    if ('OP' === ieTipoAnexo) {
      this.panelOpme.setVisible(true);
      return;
    }

    this.panelQuimio.setVisible(true);
  }
}
